import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

const SessionErrorHandler: React.FC = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (auth.isLoading) {
      return;
    }

    if (auth.error) {
      const currentPath = window.location.pathname;
      const callbackUrl = encodeURIComponent(currentPath);
      navigate(`/login?error=AuthError&callbackUrl=${callbackUrl}`, { replace: true });
    }
  }, [auth.error, auth.isLoading, navigate]);

  useEffect(() => {
    const error = searchParams.get('error');
    if (error) {
      sessionStorage.setItem('auth_error', error);
    }
  }, [searchParams]);

  return null;
};

export default SessionErrorHandler;
